export function getInsuranceDocument(state) {
    return state.insurance_document
}

export function getInsuranceAgentName(state) {
    return state.insurance_agent?.name ?? 'No Agent'
}

export function getInsuranceAgentId(state) {
    return state.insurance_agent?.id ?? null
}

export function getInsuranceAgents(state) {
    return state.agents
}



